var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalesComercialesWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Locales_Comerciales_white",
    "data-name": "Locales Comerciales_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.978,
    height: 53.251,
    viewBox: "0 0 50.978 53.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M503.407,515.875a6.508,6.508,0,0,0,6.5-6.5v-4.088a2.444,2.444,0,1,0-1.56,0v4.083a4.941,4.941,0,0,1-9.881,0v-4.083a2.443,2.443,0,1,0-1.552,0v4.083A6.508,6.508,0,0,0,503.407,515.875Zm5.722-13.779a.884.884,0,1,1-.883.885h0A.884.884,0,0,1,509.129,502.1Zm-11.442,0a.884.884,0,1,1-.883.885h0A.884.884,0,0,1,497.688,502.1Z",
    transform: "translate(-465.492 -469.08)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M218.62,258.481h46.252a2.008,2.008,0,0,0,2.005-2.008,2.061,2.061,0,0,0-.012-.213l-.911-8.307a.78.78,0,1,0-1.551.169h0l.911,8.307a.445.445,0,0,1-.394.491.375.375,0,0,1-.049,0H242.758a.444.444,0,0,1-.446-.443.4.4,0,0,1,0-.051l2.249-20.524a.443.443,0,0,1,.443-.4h17.618a.445.445,0,0,1,.443.4L264,244.48a.78.78,0,1,0,1.551-.169h0l-.939-8.578a2,2,0,0,0-1.994-1.787H254l-1.208-11a2.719,2.719,0,0,0-2.7-2.425h-3.107v-4.448a10.846,10.846,0,0,0-21.692,0v4.448h-3.1a2.717,2.717,0,0,0-2.705,2.425l-3.562,32.515a2.723,2.723,0,0,0,2.413,3A2.672,2.672,0,0,0,218.62,258.481Zm-1.153-2.848,3.562-32.511a1.16,1.16,0,0,1,1.153-1.038h3.1v2.905a2.539,2.539,0,1,0,1.56,0v-2.905h7.466a.781.781,0,0,0,0-1.56h-7.466v-4.448a9.286,9.286,0,1,1,18.572-.007v4.456h-7.464a.781.781,0,0,0,0,1.56h7.466v2.905a2.539,2.539,0,1,0,1.56,0v-2.906h3.1a1.16,1.16,0,0,1,1.151,1.038l1.185,10.823h-7.415a2,2,0,0,0-1.994,1.787l-2.249,20.525a2.107,2.107,0,0,0,.038.664H218.62a1.16,1.16,0,0,1-1.161-1.16A1.03,1.03,0,0,1,217.466,255.633Zm8.6-29.209a.979.979,0,1,1-.978.98h0a.978.978,0,0,1,.978-.98Zm20.129,0a.979.979,0,1,1-.978.98h0a.978.978,0,0,1,.98-.978h0Z",
    transform: "translate(-215.898 -205.23)",
    fill: "#f5f5f5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalesComercialesWhite);
export default __webpack_public_path__ + "static/media/Locales Comerciales_white.4c51c292225e033075bc688102f5ce7c.svg";
export { ForwardRef as ReactComponent };